import type {
  DirectiveResult,
  SYSForm,
  TemplateResult,
  UnsafeHTMLDirective,
} from "../../"
import { html, unsafeHTML } from "../../"
import { SYSBaseElement } from "../sysbaseelement"

export type DialogChangedParam = {
  dialogState: ModalDialogState
  result: ResultType
}
export type _DialogOkType = "SYSOk" | "SYSYes" | "NoButton" | string
export type _DialogCancelType = "SYSCancel" | "SYSNo" | "NoButton" | string

export type ResultType = undefined | 1 | 2 | 3

export type OpenModalDialogState = {
  title: string | TemplateResult | UnsafeHTMLDirective | DirectiveResult
  customClass: string
  type: DialogType
  text: string | TemplateResult | UnsafeHTMLDirective | DirectiveResult
  ok: _DialogOkType
  cancel: _DialogCancelType
  freeButton1?: string
  default: ResultType
  instance?: any
  connectedForm?: { formType: string; formId: string }
}
export type ModalDialogState = {
  title: string | TemplateResult | UnsafeHTMLDirective | DirectiveResult
  customClass: string
  type: DialogType
  text: string | TemplateResult | UnsafeHTMLDirective | DirectiveResult
  okText: string
  cancelText: string
  freeButton1Text?: string
  result: ResultType
  default: ResultType
  instance?: any
  connectedForm?: { formType: string; formId: string }
}

import { SYSFormField } from "../forms/fieldapi"
import { DialogType } from "./sysdialogbase"
import { _DialogHolderParams } from "./sysdialogholder"
import { FormIsDirty, FormIsValid, FormReset } from "../forms/formapi"
import { T } from "../../textapi"
import { DialogResult } from "../actions"
import { DialogOkCancel } from "./dialogapi"

export class SYSDialog extends SYSBaseElement {
  modaldialog: ModalDialogState

  constructor() {
    super()
    this.dialog = "SYSModal"
  }
  async init() {
    this.modaldialog = this.state.ovl.libState.dialog[this.dialogInstance]
    await super.init()
  }

  handleResult(result: ResultType) {
    this.actions.ovl.internal._DialogChanged({
      dialogState: this.modaldialog,
      result: result,
    })
  }

  handleOkClick = () => {
    this.actions.ovl.internal._DialogChanged({
      dialogState: this.modaldialog,

      result: 1,
    })
  }

  handleCancelClick = async () => {
    if (this.formState) {
      if (FormIsDirty(this.formState)) {
        if (
          (await DialogOkCancel(T("SYSCancelForm"), {
            instance: "CancelForm",
            cancelText: "SYSNo",
          })) === 1
        ) {
          FormReset(this.formState)
        }
      }
    }

    this.actions.ovl.internal._DialogChanged({
      dialogState: this.modaldialog,
      result: 2,
    })
  }

  handleFreeButton1Click = () => {
    this.actions.ovl.internal._DialogChanged({
      dialogState: this.modaldialog,
      result: 3,
    })
  }

  handleDefault(def: ResultType) {
    if (
      (def == 1 && this.modaldialog.okText == "") ||
      (def == 2 && this.modaldialog.cancelText == "") ||
      (def == 2 && this.modaldialog.freeButton1Text == "")
    ) {
      return
    }
    this.actions.ovl.internal._DialogDefaultChanged({
      default: def,
      instance: this.dialogInstance,
    })
  }

  keyHandler = (e: KeyboardEvent) => {
    //@ts-ignore
    if ("ovl-dialog,ovldialogok,ovldialogcancel".indexOf(e.target.id) < 0) {
      return
    }

    e.preventDefault()
    e.stopPropagation()

    if (e.key == "Enter") {
      if (this.modaldialog.default == 1) {
        this.handleResult(1)
      } else if (this.modaldialog.default == 2) {
        this.handleResult(2)
      } else {
        this.handleResult(3)
      }
      // } else if (e.key == "ArrowRight") {
      //   if (this.modaldialog.default == 1) {
      //     this.handleDefault(2)
      //   }
      // } else if (e.key == "ArrowLeft") {
      //   if (this.modaldialog.default == 2) {
      //     this.handleDefault(1)
      //   }
      // } else if (e.key == "Tab") {
      //   if (this.modaldialog.default == 2) {
      //     this.handleDefault(1)
      //   } else {
      //     this.handleDefault(2)
      //   }
    } else if (e.key === "Escape") {
      if (this.modaldialog.cancelText !== "NoButton") {
        this.handleDefault(2)
        setTimeout(() => {
          this.handleResult(2)
        }, 100)
      } else {
        this.handleResult(1)
      }
    }
  }
  getBody = () => {
    this.modaldialog = this.state.ovl.libState.dialog[this.dialogInstance]
    let lines
    let text = this.modaldialog.text

    if (typeof text === "string") {
      return unsafeHTML(text.replace(/\r?\n/g, "<br />"))
    } else {
      lines = text
    }
    return lines
  }
  getFooter = () => {
    this.modaldialog = this.state.ovl.libState.dialog[this.dialogInstance]
    let okButton = null
    let cancelButton = null
    let freeButton1 = null
    if (this.modaldialog.okText) {
      let disabled = this.formState && !FormIsValid(this.formState)
      okButton = html`<div class="fd-bar__element">
        <button
          ?disabled=${disabled}
          @click=${this.handleOkClick}
          class=${`fd-dialog__decisive-button fd-button ${
            this.modaldialog.okText == "" ? " hide" : ""
          }`}
          aria-selected=${this.modaldialog.default === 1}
          id="ovldialogok"
        >
          ${this.modaldialog.okText}
        </button>
      </div> `
    }

    if (this.modaldialog.cancelText) {
      cancelButton = html`
        <div class="fd-bar__element">
          <button
            @click=${this.handleCancelClick}
            class=${`fd-dialog__decisive-button fd-button ${
              this.modaldialog.cancelText == "" ? " hide" : ""
            }`}
            aria-selected=${this.modaldialog.default === 2}
            id="ovldialogcancel"
          >
            ${this.modaldialog.cancelText}
          </button>
        </div>
      `
    }

    if (this.modaldialog.freeButton1Text) {
      freeButton1 = html`
        <div class="fd-bar__element">
          <button
            @click=${this.handleFreeButton1Click}
            class=${`fd-dialog__decisive-button fd-button ${
              this.modaldialog.cancelText == "" ? " hide" : ""
            }`}
            aria-selected=${this.modaldialog.default === 3}
            id="ovldialogfree1"
          >
            ${this.modaldialog.freeButton1Text}
          </button>
        </div>
      `
    }

    return html`${okButton} ${cancelButton} ${freeButton1}`
  }

  async getUI() {
    this.modaldialog = this.state.ovl.libState.dialog[this.dialogInstance]
    let dependsOn = this.dialogState.visible
    if (!dependsOn) {
      return null
    }
    let dialogHolderParams: _DialogHolderParams
    // tracking needs to be recorded on the hiolder object
    // thats why we use functions here to get the templates
    // to make it look nicer i even used methods for the different parts
    dialogHolderParams = {
      dialogParts: {
        title: () => this.modaldialog.title,
        body: async () => await this.getBody(),
        footer: () => this.getFooter(),
        keyHandlerFn: this.keyHandler,
        dismissedCallbackFn: () => {},
        type: () => this.modaldialog.type,
        customClass: () => this.modaldialog.customClass,
      },

      dialogType: this.dialogState.dialog,
      instance: this.dialogState.instance,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
